import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import TextArea from '../../common/TextArea';
import ColorPicker2 from '../../common/ColorPicker2';
import Select from '../../common/Select';
import ReactMultiSelectWrapper from '../../common/ReactMultiSelectWrapper';
import DatePicker from '../../common/DatePicker';
import FinInfo from '../../common/FinInfo';
import SuppliesLog from '../../common/SuppliesLog';
import Materials from '../../common/Materials';
import '../../css/forms/default-forms.css';
import { fetchProjectById, getList, getContactsByProjectId } from '../../api/projects';
import {
  fetchTaskById,
  getPdfFile,
  getPdfFileInvoice,
  getPdfFileShipping,
  updateTaskProject,
  updateTaskById,
  updateTaskByIdAndSendMail,
  getPaintListAll,
  getWORecent,
  getSalesPersonsListAll,
} from '../../api/task';
import { getVendorsList } from '../../api/vendors';
import {
  bindFieldAndData,
  getValue,
  getDataFieldType,
  buildOptionsFromStr,
} from './data';
import { getJobCards } from '../../api/jobCards';
import { basic as fields } from './fields';
import {
  fetchDetailsWithoutProperty,
  fetchAllTasks,
  transferEmailByTaskIdAndStageId,
  adjustTaskPositionByTaskIdAndPosition,
  deleteWOById,
} from '../../api/dashboard';
import moment from 'moment';
import 'moment-timezone';
import * as R from 'ramda';
import { convertPercentsToCol } from '../../helpers/woGrid';
import { deleteObject } from '../../actions/objectToDelete';
import { changeModalState } from '../../actions/modal';
import ConfirmAction from '../../common/ConfirmAction';
import Preloader from '../../common/Preloader';
import hasAccess from "../../helpers/permissionChecker";
import { validateFields } from '../../utils/validate';
import PopUp from '../../common/PopUp';
import CKEditorComponent from "../../сomponents/CKEditor";
import { notificationsChanged } from '../../utils/notifications';
import {goToTimesheet} from "../../actions/checkIn";
import {getCurrentTimeZone} from "../../utils/date";

export class QuoteAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      submit: false,
      errors: [],
      fields: clone(fields),
      materialsData: [{
        id: Math.random(),
        material_id: '',
        name: '',
        quantity: '',
        unit_of_measure: '',
        price: '',
        subtotal: '',
      }],
      supplieDataV2: [],
      data: [],
      fixedSuppliesLogData: false,
      details: [],
      projectId: undefined,
      projectName: '',
      loading: true,
      loaded: false
    };

    this.ckeEditorScopeOfWordRef = element => {
      this.scopeOfWordRef = element;
    };

    this.submit = this.submit.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.changeSuppliesLogV2 = this.changeSuppliesLogV2.bind(this);
    this.removeSuppliesLogV2 = this.removeSuppliesLogV2.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.remove = this.remove.bind(this);
    this.donwloadPdfPreview = this.donwloadPdfPreview.bind(this);
    this.downloadPdfInvoice = this.downloadPdfInvoice.bind(this);
    this.downloadPdfPreviewShipping = this.downloadPdfPreviewShipping.bind(this);
    this.renderFields = this.renderFields.bind(this);
    this.linkProjects = this.linkProjects.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.renderSendEmailButton = this.renderSendEmailButton.bind(this);
    this.sendEmailNotification = this.sendEmailNotification.bind(this);
    this.attachFile = this.attachFile.bind(this);
    this.getMaterialsCost = this.getMaterialsCost.bind(this);
    this.logs = this.logs.bind(this);
    this.comments = this.comments.bind(this);
    this.clock = this.clock.bind(this);
    this.changeFinancialInfo = this.changeFinancialInfo.bind(this);
    this.changeSuppliesLog = this.changeSuppliesLog.bind(this);
    this.fixSuppliesLogData = this.fixSuppliesLogData.bind(this);
    this.changeMaterials = this.changeMaterials.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.processFieldsToSave = this.processFieldsToSave.bind(this);
    this.parseContactList = this.parseContactList.bind(this);
    this.parseCustomersList = this.parseCustomersList.bind(this);
    this.handleAddContacts = this.handleAddContacts.bind(this);
  }

  componentWillMount() {
    this.props.getPaintList();
    this.fetchDataRouteById();
    this.props.getCustomerList();
    this.props.getJobCardsTypes();
    this.props.getProjects();
    this.props.getTasks();
    this.props.getSalesPersonsList();
    this.props.getVendors();
  }

  componentDidUpdate() {
    const { loading, data } = this.state;
    const fieldsDetail = path(['tasks', 'current', 'fields_detail'], this.props)
    const projectId = path(['tasks', 'current', 'project_id'], this.props)
    if (loading && data && fieldsDetail) {
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    setTimeout(function() {
      document.querySelector('.left-sidebar-placeholder').style.display = 'block';
      document.querySelector('.left-sidebar-1').style.display = 'block';
    }, 0);
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  componentWillReceiveProps(nextProps) {
    // skip processing if only notifications changed
    if (notificationsChanged(this.props, nextProps)) {
      return;
    }

    const stateClone = clone(this.state);
    let shouldSetState = false;
    const fields = path(['tasks', 'current', 'fields'], nextProps);
    const fields_detail = path(['tasks', 'current', 'fields_detail'], nextProps);
    const materials = path(['tasks', 'current', 'materials'], nextProps) || [];

    stateClone.materialsData = materials.map((item) => ({
      id: item.id || Math.random(),
      originId: item.id,
      material_id: item.material_id,
      name: item.name,
      quantity: item.quantity,
      unit_of_measure: item.unit_of_measure,
      price: item.price,
      subtotal: Number(item.subtotal),
    }));
    stateClone.materialsData.push({
      id: Math.random(),
      material_id: '',
      name: '',
      quantity: '',
      unit_of_measure: '',
      price: '',
      subtotal: '',
    });

    const supplieDataV1 = path(['tasks', 'current', 'supplies_log'], this.props) || [];
    const supplieDataV2 = path(['tasks', 'current', 'supplies_log'], nextProps) || [];

    const supplyLogChanged = supplieDataV1 !== supplieDataV2;

    if (supplyLogChanged) {
      stateClone.supplieDataV2 = supplieDataV2.map((item) => ({
        id: item.id || `${Date.now()}-${Math.round(Math.random() * 10000)}`,
        frontend_suplog_id: item.frontend_suplog_id || `${Date.now()}-${Math.round(Math.random() * 10000)}`,
        vendor: item.vendor_id,
        comments: item.comment,
        include_in_the_email: item.include_in_the_email,
        email_sent_date: item.email_sent_date,
        materials: [...item.materials.map((matItem) => ({
          id: matItem.id || Math.random(),
          originId: matItem.id,
          material_id: matItem.material_id,
          name: matItem.name,
          quantity: matItem.quantity,
          price: matItem.price,
          subtotal: Number(matItem.subtotal),
        })), {
          id: Math.random(),
          material_id: '',
          name: '',
          quantity: '',
          price: '',
          subtotal: '',
        }],
      }));
    } else {
      // console.log('--- supplyLogChanged --- ');
      // console.log(['supplyLogChanged, supplieDataV1, supplieDataV2', supplyLogChanged, supplieDataV1, supplieDataV2])
    }

    if (fields && fields_detail) {
      let newArr = bindFieldAndData(fields, fields_detail);
      stateClone.details = path(['tasks', 'current', 'details'], nextProps);
      stateClone.data = this.fixPaintListDataStructure(newArr);
      shouldSetState = true;
    }

    const projectId = path(['tasks', 'current', 'project_id'], nextProps);
    const currentProjectId = path(['projects', 'currentProject', 'id'], nextProps);
    const currentProjectIdValue = path(['tasks', 'current', 'project_id'], this.props);
    const stateProjectId = path(['fields', 'project_id', 'value'], this.state);
    if (
      projectId !== undefined
      && (
        projectId !== currentProjectId
        || currentProjectIdValue === undefined
        || (
          !stateProjectId
          && projectId === currentProjectIdValue
          && projectId === currentProjectId
        )
      )
    ) {
      this.props.getContactList(projectId);
      this.props.getCurrentProject(projectId);
      stateClone.fields.project_id.value = projectId;
      shouldSetState = true;
    }

    const currentContacts = path(['tasks', 'current', 'contacts'], nextProps);
    if (
      projectId
      && projectId === currentProjectId
      && currentProjectIdValue == projectId
      && currentContacts
    ) {
      stateClone.fields.contacts.value = currentContacts;
      shouldSetState = true;
    }

    const salesRepId = path(['tasks', 'current', 'sales_rep_id'], nextProps);
    if (salesRepId) {
      stateClone.fields.sales_rep_id.value = salesRepId;
      shouldSetState = true;
    }

    if (shouldSetState) {
      this.setState((prevState) => mergeDeepLeft(stateClone, prevState));
    }
  }

  fixPaintListDataStructure(arrData) {
    for (let i = arrData.length; i--;) {
      if (arrData[i].label == 'Paint List') {
        let newArr = [];
        if (arrData[i].content && arrData[i].content.length > 0) {
          const newstringreplaced = arrData[i].content.replace(/},"/gi, "}}|||{\"");
          const stringData = newstringreplaced.split('|||');
          for (let data of stringData) {
            let dataObject;
            try {
              dataObject = JSON.parse(data);
            }
            catch (e) {
              dataObject = '';
            }
            if (!R.isEmpty(dataObject)) {
              const email = Object.keys(dataObject)[0];
              if (email) {
                const dataCheckedProp = dataObject[email];
                dataCheckedProp.checked = false;
                newArr.push({
                  emails: email,
                  data: dataCheckedProp,
                });
              }
            }
          }
          arrData[i].content = newArr;
        } else {
          arrData[i].content = [];
        }
      }
    }

    return arrData;
  }

  processFieldsToSave(lane_id) {
    const data = this.state.data;
    let processedData = {};
    let paintList = {};

    for (let i = 0; i < data.length; i++) {
      if (data[i].label == 'Paint List') {
        paintList = data[i].content;
      } else {
        processedData[data[i].detailsId] = data[i].content;
      }
    }

    let laneID = this.state.details.lane_id;
    if (lane_id) {
      laneID = lane_id;
    }

    const supplies_log =  this.state.supplieDataV2.filter((item) => Boolean(item.vendor)).map((item) => ({
      frontend_suplog_id: item.frontend_suplog_id,
      vendor_id: item.vendor,
      comment: item.comments,
      include_in_the_email: item.include_in_the_email === undefined ? false : item.include_in_the_email,
      materials: item.materials.filter((matItem) => Boolean(matItem.name)).map((matItem) => ({
        name: matItem.name,
        material_id: matItem.material_id,
        price: Number(matItem.price.replace(',', '')).toFixed(2).toString(),
        quantity: Number(matItem.quantity).toString(),
        subtotal: Number(matItem.subtotal).toFixed(2).toString(),
      })),
    }));

    return {
      data: JSON.stringify(processedData),
      project_id: path(['fields', 'project_id', 'value'], this.state),
      contacts: path(['fields', 'contacts', 'value'], this.state),
      sales_rep_id: path(['fields', 'sales_rep_id', 'value'], this.state),

      lane_id: laneID ? laneID : 0,
      stage_id: this.state.details.stage_id ? this.state.details.stage_id : 0,
      board_id: 1,

      pl: JSON.stringify(paintList),
      pl_d: [],
      vte: '',

      materials: this.state.materialsData.filter((item) => Boolean(item.name)).map((item) => ({
        id: item.originId,
        name: item.name,
        material_id: item.material_id,
        price: Number(item.price.replace(',', '')).toFixed(2).toString(),
        quantity: Number(item.quantity).toString(),
        unit_of_measure: item.unit_of_measure,
        subtotal: Number(item.subtotal).toFixed(2).toString(),
      })),
      supplies_log: supplies_log
    };
  }

  getMaterialsCost() {
    const materialsCost = this.state.materialsData
      .filter((item) => Boolean(item.name))
      .reduce((acc, item) => acc + Number(item.subtotal), 0);
    const suppliesCost = this.state.supplieDataV2
      .filter((item) => Boolean(item.vendor))
      .reduce((acc, item) => item.materials
        .filter((matItem) => Boolean(matItem.name))
        .reduce((acc2, matItem) => acc2 + Number(matItem.subtotal), acc), 0);

    return materialsCost + suppliesCost;
  }

  sendEmail(supId) {
    const id = path(['match', 'params', 'id'], this.props);
    const fields = {...this.state.fields};
    if (typeof fields.project.value === 'object' ) {
      fields.project.value = '';
    }
    let laneID = fields.project.value || null;
    let result = validateFields(fields);

    if (result.check === true) {
      this.props.editAndSendMail(id, this.processFieldsToSave(laneID), supId);
    } else {
      this.setState({ fields: result.fields });
    }
  }

  submit(e) {
    e.preventDefault();
    const id = path(['match', 'params', 'id'], this.props);
    const fields = {...this.state.fields};
    if (typeof fields.project.value === 'object' ) {
      fields.project.value = '';
    }
    let laneID = fields.project.value || null;

    const skopeOfWorkField = this.state.data.find(x => x.label == 'Scope of Work');
    if (skopeOfWorkField) {
      skopeOfWorkField.content = this.scopeOfWordRef.editor.getData();
    }

    let result = validateFields(fields);

    if (result.check === true) {
      this.props.editTask(id, this.processFieldsToSave(laneID));
    } else {
      this.setState({ fields: result.fields });
    }
  }

  generateWOField() {
    let stateClone = clone(this.state);
    return this.props.getWoIdForCustomer(
      parseInt(stateClone.fields['project_id'].value)
    );
  }

  changeFormValue(field, newObject) {
    console.log('On Change', field, newObject)
    let stateClone = clone(this.state);
    if (typeof field == 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    if (field == 'project') {
      stateClone.details[0].lane_id = newObject.value;
    }

    if (field == 'project_id') {
      if (newObject.value) {
        this.props.getContactList(newObject.value);
      }

      this.generateWOField().then((data) => {
        const woField = R.find(R.propEq('label', 'Work Order'), stateClone.data);
        woField.content = data;
        this.setState({ loaded: true });
        stateClone.fields.contacts.value = [];
        stateClone.loaded = true;
        this.setState((prevState) => mergeDeepLeft(stateClone, prevState));
      });
    } else {
      this.setState(mergeDeepLeft(stateClone, this.state));
    }
  }

  parseContactList(arr) {
    const arrContacts = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (typeof arr[i] !== 'object') continue;
        let type = arr[i].type.join('/');
        type = type ? ` (${type})`:type;
        const phone = arr[i].phone ? `, tel.: ${arr[i].phone}`: '';
        const email = arr[i].email ? `, email.: ${arr[i].email}`: '';

        arrContacts.push({
          value: arr[i].id,
          label: `${arr[i].firstname} ${arr[i].lastname}${phone}${email}${type}`,
          name: `${arr[i].firstname} ${arr[i].lastname}`
        });
      }
    }

    return arrContacts;
  }

  parseCustomersList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          text: arr[i].name,
        });
      }
    }

    return arrCustomers;
  }

  parseSalesPersonsList(salesPersonsList) {
    return (salesPersonsList || []).map((item) => ({
      value: item.id,
      label: `${item.firstname} ${item.lastname}`,
    }));
  }

  donwloadPdfPreview() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getPdf(id, id);
  }

  downloadPdfInvoice() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getPdfInvoice(id);
  }

  downloadPdfPreviewShipping() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getPdfShipping(id);
  }

  remove() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteWOById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteWOById',
    });
  }

  changeFinancialInfo(name, field) {
    const data = this.state.data;

    for (let i = 0; i < data.length; i++) {
      if (data[i].label == 'Financial Info') {
        let currentJson = null;

        if (typeof data[i].content == 'string' && data[i].content.indexOf('{') !== -1) {
          try {
            currentJson = JSON.parse(data[i].content);
          } catch (e) {
            currentJson = data[i].content;
          }
          ;
        }

        if (currentJson === null) {
          currentJson = {
            'material': '',
            'labor': '',
            'price': '',
            'price-paint': '',
            'price-body': '',
            'taxes': '',
            'body-work': ''
          };
        }

        currentJson[name] = field.value;
        let stateClone = clone(this.state);
        stateClone.data[i].content = JSON.stringify(currentJson);
        this.setState(mergeDeepLeft(stateClone, this.state));
      }
    }
  }

  createUniqueName(name, data) {
    let nameCounter = 0;

    for (let key in data) {
      if (key.indexOf(name) !== -1) {
        nameCounter += 1;
      }
    }

    return name + ` `;
  }

  // Supplies Log Data Save
  changeSuppliesLog(name, field, parentField) {
    if (field == 'delete') {
      const data = this.state.data;

      for (let i = 0; i < data.length; i++) {
        if (data[i].label == 'Paint List') {
          const currentJson = [...data[i].content];

          delete currentJson[name];

          let stateClone = clone(this.state);
          stateClone.data[i].content = currentJson;
          this.setState(mergeDeepLeft(stateClone, this.state));
        }
      }
    } else if (field == 'add') {
      const data = this.state.data;

      for (let i = 0; i < data.length; i++) {
        if (data[i].label == 'Paint List') {
          const currentJson = [...data[i].content];

          if (Array.isArray(currentJson)) {
            currentJson.push({
              emails: '',
              data: {
                id: 0,
                paint: null,
                checked: false,
              },
            });
          }

          let stateClone = clone(this.state);
          stateClone.data[i].content = currentJson;
          this.setState(mergeDeepLeft(stateClone, this.state));
        }
      }
    } else if (field == 'delete_all') {
      const data = this.state.data;

      for (let i = 0; i < data.length; i++) {
        if (data[i].label == 'Paint List') {
          let stateClone = clone(this.state);
          stateClone.data[i].content = [];
          this.setState(mergeDeepLeft(stateClone, this.state));
        }
      }
    } else {
      // Convert name
      if (name == 'input') {
        name = 'id';
      } else if (name == 'checkbox') {
        name = 'checked';
      } else {
        name = 'paint';
      }

      const data = this.state.data;

      for (let i = 0; i < data.length; i++) {
        if (data[i].label == 'Paint List') {
          const currentJson = data[i].content;

          if (field.label == 'Mail to Vendor' && currentJson[parentField]) {
            currentJson[parentField].data.checked = field.value;
          } else if (field.label == 'Supplies') {
            currentJson[parentField].data.paint = field.value;
          } else if (field.label == 'Emails') {
            currentJson[parentField].emails = field.value;
          } else if (field.label == 'Mail will be sent if you save this change to Work Order') {
            currentJson[parentField].data.checked = field.value;
          } else {
            currentJson[parentField].data = field.value;
          }

          let stateClone = clone(this.state);
          stateClone.data[i].content = currentJson;

          this.setState(mergeDeepLeft(stateClone, this.state));
        }
      }
    }
  }

  fixSuppliesLogData() {
    if (this.state.fixedSuppliesLogData === false) {
      const stateClone = clone(this.state);
      const data = stateClone.data;

      for (let i = 0; i < data.length; i++) {
        if (data[i].label == 'Paint List') {
          // Add checkbox state
          const content = JSON.parse(data[i].content);

          for (let key in content) {
            let currentList = content[key];
            currentList['checked'] = false;
          }

          data[i].content = JSON.stringify(content);
        }
      }

      // Set fix for data as true
      stateClone.fixedSuppliesLogData = true;

      this.setState(mergeDeepLeft(stateClone, this.state));
    }
  }

  removeSuppliesLogV2(id) {
    this.props.handleObjectToDelete({
      id: id,
      handler: data => {
        if (id) {
          const index = this.state.supplieDataV2.findIndex((x) => x.id === data.id);

          if (index > -1) {
            this.setState({supplieDataV2: this.state.supplieDataV2.splice(index, 1)});
          }
        } else {
          const supplieDataV2 = this.state.supplieDataV2;
          const state = {
            supplieDataV2: supplieDataV2.splice(0, supplieDataV2.length),
            data: this.state.data ? clone(this.state.data) : {}
          };
          const paintList = state.data.find(v => v.label == 'Paint List');
          if (paintList) {
            paintList.content = [];
          }

          this.setState(state);
        }
      }
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: id ? 'deleteSlById' : 'deleteSlAll',
    });
  }

  changeSuppliesLogV2(value, field, parentField) {
    const stateClone = clone(this.state);
    switch (field) {
      case 'add': {
        stateClone.supplieDataV2.push({
          id: `${Date.now()}-${Math.round(Math.random() * 10000)}`,
          frontend_suplog_id: `${Date.now()}-${Math.round(Math.random() * 10000)}`,
          vendor: null,
          comments: '',
          include_in_the_email: false,
          materials: [{
            id: Math.random(),
            material_id: '',
            name: '',
            quantity: '',
            price: '',
            subtotal: '',
          }],
        });
        break
      }
      case 'delete': {
        const index = stateClone.supplieDataV2.findIndex((data) => data.id === value);

        if (index > -1) {
          stateClone.supplieDataV2.splice(index, 1);
        }
        break;
      }
      case 'delete_all': {
        stateClone.supplieDataV2 = [];
      }
      case 'materials': {
        const index = stateClone.supplieDataV2.findIndex((data) => data.id === parentField);

        if (index > -1) {
          const materials = stateClone.supplieDataV2[index].materials;

          if (value.name === 'delete') {
            materials.splice(value.index, 1);

            if (!materials.length) {
              materials.push({
                id: Math.random(),
                material_id: '',
                name: '',
                quantity: '',
                price: '',
                subtotal: '',
              });
            }
          } else {
            if (value.name === 'material') {
              const data = value.value;

              materials[value.index].material_id = data.value;
              materials[value.index].name = data.label;
              materials[value.index].price = data.cost;
            } else if (value.name === 'delete') {
              materials.splice(index, 1);
            } else {
              materials[value.index][value.name] = value.value.split(',').join('');
            }
            materials[value.index].subtotal = (materials[value.index].price || 0) * (materials[value.index].quantity || 0);
            materials[value.index] = { ...materials[value.index] };

            if (materials[materials.length - 1].name) {
              materials.push({
                id: Math.random(),
                material_id: '',
                name: '',
                quantity: '',
                price: '',
                subtotal: '',
              });
            }
          }

          stateClone.supplieDataV2[index] = { ...stateClone.supplieDataV2[index], 'materials': [...materials] };
        }
        break;
      }
      default: {
        const index = stateClone.supplieDataV2.findIndex((data) => data.id === parentField);

        if (index > -1) {
          stateClone.supplieDataV2[index] = { ...stateClone.supplieDataV2[index], [field]: value };
        }
        break;
      }
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  changeMaterials(index, field, value) {
    if (field === 'delete') {
      let stateClone = clone(this.state);

      stateClone.materialsData.splice(index, 1);

      this.setState(mergeDeepLeft(stateClone, this.state));
    } else {
      let stateClone = clone(this.state);

      if (field === 'material') {
        if (value) {
          const addNew = !stateClone.materialsData[index].name;

          if (value.label === value.value) {
            stateClone.materialsData[index].price = '0';
          } else {
            stateClone.materialsData[index].material_id = value.value;
            stateClone.materialsData[index].price = value.cost;
          }
          stateClone.materialsData[index].name = value.label;
          stateClone.materialsData[index].quantity = '1';
          stateClone.materialsData[index].unit_of_measure = value.unit_of_measure;

          if (addNew) {
            stateClone.materialsData.push({
              id: Math.random(),
              material_id: '',
              name: '',
              quantity: '',
              unit_of_measure: '',
              price: '',
              subtotal: '',
            });
          }
        }
      } else {
        stateClone.materialsData[index][field] = value;
      }

      stateClone.materialsData[index].subtotal =
      Number(stateClone.materialsData[index].price.replace(',', '')) *  Number(stateClone.materialsData[index].quantity);

      this.setState(mergeDeepLeft(stateClone, this.state));
    }
  }

  changeValue(name, field) {
    const stateClone = clone(this.state);

    for (let i = stateClone.data.length; i--;) {
      if (stateClone.data[i].id == name) {
        // Convert date
        if (Object.prototype.toString.call(field.value) === '[object Date]') {
          field.value = moment.tz(field.value, getCurrentTimeZone()).format('M/D/YYYY h:mm A');
        }
        stateClone.data[i].content = field.value;
      }
    }
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  getStatusStaticOptions() {
    return [
      {
        value: 'new',
        text: 'New',
      },
      {
        value: 'hold',
        text: 'Hold',
      },
      {
        value: 'in_progress',
        text: 'In Progress',
      },
      {
        value: 'hot',
        text: 'HOT',
      },
      {
        value: 're_work',
        text: 'Re-work',
      },
      {
        value: 'ready',
        text: 'Ready',
      },
      {
        value: 'closed',
        text: 'Closed',
      },
    ];
  }

  fixSuppliesLogStructure(data) {
    return data;
  }

  getPermission(permAreaKey, permTypeKey) {
    if (!permTypeKey) {
      permTypeKey = 'view';
    }

    const perm = this.props.users.userProfile.permission.find(item => item.permAreaKey === permAreaKey && item.permTypeKey === permTypeKey);
    return perm && perm.value === 'on';
  }

  renderFields(disableFieldForEdit) {
    const arrFields = [];
    const jobCardsType = path(['tasks', 'current', 'jobcard_types'], this.props) || [];
    const fieldsDetail = path(['tasks', 'current', 'fields_detail'], this.props) || [];
    const paintListAll = path(['tasks', 'paintListAll'], this.props) || [];
    const vendorsList = path(['vendors', 'list'], this.props) || [];
    const field = {
      label: null,
      value: '',
      errors: [],
      style: {
        grid: null,
      },
      name: null,
      system: {
        name: null,
      },
      rules: {
        title: null,
      }
    };

    if (this.state.data && this.state.data.length > 0 && fieldsDetail) {
      const data = [...this.state.data];
      data.sort((a, b) => a.order - b.order);
      for (let i = 0; i < data.length; i++) {
        const currentField = clone(field);
        const currentData = data[i];
        // Fields settings
        const currentFieldData = fieldsDetail[currentData.detailsId];
        if (!currentFieldData || currentFieldData.enabled === 0) {
          continue;
        }
        const type = getDataFieldType(currentFieldData);

        // Set current field
        currentField.value = currentData.content;
        currentField.label = currentData.label;
        const widthFromOptions = R.path(['options', 'width'], currentFieldData);
        let fieldWidth = 'col-12';
        if (widthFromOptions) {
          fieldWidth = convertPercentsToCol(currentFieldData.options.width);
        }
        // Set name
        if (currentData.id !== null) {
          currentField.name = currentData.id;
          currentField.system.name = currentData.id;
        } else {
          currentField.name = 'field_' + i;
          currentField.system.name = 'field_' + i;
        }

        if (currentData.label.toLowerCase() == 'status') {
          currentField.value = getValue(currentField, currentData);
        } else if (currentData.label.toLowerCase() == 'card type') {
          const jcList = path(['jobCards', 'list'], this.props) || [];
          currentField.value = getValue(currentField, currentData, jcList);
        }

        const viewFinPerm = this.getPermission("work_order_financial", "view");
        const editFinPerm = this.getPermission("work_order_financial", "edit");
        const viewMatPricesPerm = this.getPermission("material_prices", "view");
        const editMatPricesPerm = this.getPermission("material_prices", "edit");

        if (currentField.label == 'Financial Info') {
          if (viewFinPerm) {
            const { users } = this.props;

            let show = false;

            if (users && users.userProfile) {
              show = true;
            }

            if (show) {
              let data = {
                'material': '',
                'labor': '',
                'price': '',
                'price-paint': '',
                'price-body': '',
                'taxes': '',
                'body-work': ''
              };

              if (currentData && typeof currentData.content == 'string' && currentData.content.indexOf('{') !== -1) {
                data = Object.assign(data, JSON.parse(currentData.content));
              }
              arrFields.push(
                <FinInfo
                  disabled={!editFinPerm ? true : disableFieldForEdit}
                  fields={data}
                  onChange={this.changeFinancialInfo}
                  getMaterialsCost={this.getMaterialsCost}
                  cost={this.props.tasks.current.activity.cost}
                />
              );
            }
          }
        } else if (currentField.label == 'Status') {
          arrFields.push(
            <span key={i}>
                  <Select
                    disabled={disableFieldForEdit}
                    className={fieldWidth}
                    field={currentField}
                    options={this.getStatusStaticOptions()}
                    onChange={this.changeValue}
                  />
              </span>
          );
        } else if (currentField.label == 'Paint List') {
          const data = currentField.value;
          arrFields.push(
            <SuppliesLog
              disabled={disableFieldForEdit}
              paintListAll={paintListAll}
              fields={this.fixSuppliesLogStructure(data)}
              onChange={this.changeSuppliesLog}
              fieldsV2={this.state.supplieDataV2}
              onChangeV2={this.changeSuppliesLogV2}
              vendorsList={vendorsList}
              sendEmail={this.sendEmail}
              sentEmail={this.props.tasks.sentEmail}
              onRemoveV2={this.removeSuppliesLogV2}
              financialFieldsVisible={viewMatPricesPerm}
              financialFieldsDisabled={!editMatPricesPerm ? true : disableFieldForEdit}
            />
          );
        } else if (currentField.label == 'Scope of Work') {
          arrFields.push(
            <div key={i} style={{marginTop: '20px', marginBottom: '20px'}}>
                  <CKEditorComponent
                    field={currentField}
                    refLink={this.ckeEditorScopeOfWordRef}
                    disabled={disableFieldForEdit}
                  />
            </div>
          );
        } else if (currentField.label == 'Materials' || currentField.label == 'Consumables') {
          if (currentField.value) {
            arrFields.push(
              <span key={i}>
                <TextArea
                  disabled={disableFieldForEdit}
                  className={fieldWidth}
                  field={currentField}
                  onChange={this.changeValue}
                />
              </span>
            );
          }
          arrFields.push(
            <span key={`${i}-block`}>
              <Materials
                materials={this.state.materialsData}
                vendors={vendorsList}
                onChange={this.changeMaterials}
                labelPlural={currentField.label}
                financialFieldsVisible={viewMatPricesPerm}
                financialFieldsDisabled={!editMatPricesPerm ? true : disableFieldForEdit}
                disabled={disableFieldForEdit}
              />
            </span>
          );
        } else if (currentField.label == 'Paint') {
          arrFields.push(
            <span key={i}>
                  <TextArea
                    disabled={disableFieldForEdit}
                    className={fieldWidth}
                    field={currentField}
                    onChange={this.changeValue}
                  />
              </span>
          );
        } else if (currentField.label == 'PO#') {
          arrFields.push(
            <span key={i}>
                  <TextArea
                    disabled={disableFieldForEdit}
                    className={fieldWidth}
                    field={currentField}
                    onChange={this.changeValue}
                  />
              </span>
          );
        } else if (currentField.label == 'Priority') {
          arrFields.push(
            <span key={i}>
                <Select
                  disabled={disableFieldForEdit}
                  className={fieldWidth}
                  field={currentField}
                  options={this._buildOptionsFromStringWithIntKey(currentFieldData.options.option)}
                  onChange={this.changeValue}
                />
              </span>
          );
        } else if (currentField.label == 'Pick Up Time') {
          arrFields.push(
            <span key={i}>
                  <TextArea
                    disabled={disableFieldForEdit}
                    className={fieldWidth}
                    field={currentField}
                    onChange={this.changeValue}
                  />
              </span>
          );
        } else if (currentField.label == 'Notes') {
          arrFields.push(
            <span key={i}>
                  <TextArea
                    disabled={disableFieldForEdit}
                    className={fieldWidth}
                    field={currentField}
                    onChange={this.changeValue}
                  />
              </span>
          );
        } else {
          if (type == 'textbox') {
            arrFields.push(
              <span key={i}>
                    <Input
                      disabled={disableFieldForEdit}
                      className={fieldWidth}
                      field={currentField}
                      onChange={this.changeValue}
                    />
                </span>
            );
          } else if (type == 'datepicker') {
            arrFields.push(
              <span key={i}>
                    <DatePicker
                      disabled={disableFieldForEdit}
                      className={fieldWidth}
                      field={currentField}
                      onChange={this.changeValue}
                      useLocalTimeZone={true}
                    />
                </span>
            );
          } else if (type == 'dropdown') {
            arrFields.push(
              <span key={i}>
                    <Select
                      disabled={disableFieldForEdit}
                      className={fieldWidth}
                      field={currentField}
                      options={buildOptionsFromStr(currentFieldData)}
                      onChange={this.changeValue}
                    />
                </span>
            );
          } else if (type == 'jobcard_type') {
            currentField.value = currentData.content;
            arrFields.push(
              <span key={i}>
                    <ColorPicker2
                      disabled={disableFieldForEdit}
                      className={fieldWidth}
                      field={currentField}
                      value={currentField.value}
                      options={jobCardsType}
                      onChange={this.changeValue}
                    />
                </span>
            );
          } else if (type == 'textarea' || type == 'link') {
            arrFields.push(
              <span key={i}>
                    <TextArea
                      disabled={disableFieldForEdit}
                      className={fieldWidth}
                      field={currentField}
                      onChange={this.changeValue}
                    />
                </span>
            );
          } else {
            console.log('DATA :::::::::::::::::', currentField);
          }
        }
      }
    }

    return arrFields;
  }

  linkProjects() {
    const lanes = path(['dashboard', 'lanes'], this.props) || [];
    if (lanes) {
      const boardLanes = [];

      for (let i = 0; i < lanes.length; i++) {
        let currentLane = lanes[i];

        boardLanes.push({
          value: currentLane.id,
          text: currentLane.label,
        });
      }

      return boardLanes;
    }
  }

  renderForm(disableFieldForEdit) {
    const customerList = this.parseCustomersList(path(['projects', 'list'], this.props));
    const salesPersonsList = this.parseSalesPersonsList(path(['tasks', 'salesPersonsList'], this.props));
    const contactsList = this.parseContactList(path(['projects', 'contacts'], this.props));
    const selectedCustomer = this.state.fields['project_id'].value;

    const laneId = this.state.details && this.state.details.length && this.state.details[0].lane_id;
    const projectField = this.state.fields['project'];
    projectField.value = laneId;
    // console.log('-- SELECTED CONTACTS -----------------')
    // console.log(this.state.fields['contacts'].value)

    const { loaded } = this.state;

    return (
      <form onSubmit={this.submit}>
        <Select
          disabled={disableFieldForEdit}
          options={customerList}
          className={'col-12'}
          field={this.state.fields['project_id']}
          onChange={this.changeFormValue}
        />

        {contactsList && contactsList.length && (<ReactMultiSelectWrapper
              options={contactsList}
              autoFocus={false}
              field={this.state.fields['contacts']}
              onChange={this.changeFormValue}
              transformSelected={o => ({...o, title: o.label, label: o.name})}
              className='col-12'
          />) || null}

        {loaded && selectedCustomer && <PopUp
            id={'CustomerContactmissing'}
            show={contactsList && contactsList.length === 0}
            title={'Customer Contact missing'}
            onAddContacts={this.handleAddContacts}
            content={'There are no contacts assigned to the selected Customer. Please add at least one Contact to Proceed'}
            yesCaption={'Manage Customer Contacts'}
        /> }

        <Select
          placeholder={this.state.fields['project']['placeholder']}
          disabled={disableFieldForEdit}
          options={this.linkProjects()}
          className={'col-12'}
          field={this.state.fields['project']}
          onChange={this.changeFormValue}
        />

        <Select
          placeholder={this.state.fields['sales_rep_id']['placeholder']}
          disabled={disableFieldForEdit}
          options={salesPersonsList}
          className={'col-12'}
          field={this.state.fields['sales_rep_id']}
          onChange={this.changeFormValue}
        />
      </form>
    );
  }

  _buildOptionsFromStringWithIntKey(str) {
    const arr = [];
    if (str && str.length > 0) {
      const data = str.split(';');
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (data[i] && data[i].length > 0) {
            arr.push({
              value: i + 1,
              text: data[i],
            });
          }
        }
      }
    }

    return arr;
  }

  sendEmailNotification() {
    const currentId = path(['match', 'params', 'id'], this.props);
    const tasks = path(['dashboard', 'tasks'], this.props);
    let currentTask = null;

    if (currentId && tasks && tasks.length > 0) {
      for (let i = tasks.length; i--;) {
        if (tasks[i].task_id == currentId) {
          currentTask = tasks[i];
        }
      }
    }

    if (currentTask) {
      this.props.sendEmail({
        task_id: currentTask.task_id,
        stage_id: this.state.details.stage_id,
      });
    }
  }

  renderSendEmailButton() {
    const currentStage = this.state.details.stage_id;
    let button = null;
    // 8 is a hardcoded Ready stage
    if (currentStage == 89) {
      button = (
        <button
          type="button"
          className={'btn btn-warning btn-outline float-right'}
          onClick={() => { this.sendEmailNotification(); }}
          style={{ marginLeft: '10px' }}
        >
          <i className="fa fa-send"></i>
          <span style={{ paddingLeft: '3px' }}>Send Email</span>
        </button>
      );
    }

    return button;
  }

  attachFile() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.goToAttachments(id);
  }

  logs() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.goToLogs(id);
  }

  comments() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.goToComments(id);
  }

  clock() {
    const fiedls = path(['tasks', 'current', 'fields'], this.props);
    let woNumber = "";
    for (let i in fiedls) {
      if (fiedls[i].jobcard_field_id === 1) {
        woNumber = fiedls[i].content;
        break;
      }
    }

    this.props.goToClock(woNumber);
  }

  handleAddContacts() {
    const selectedCustomer = this.state.fields['customer'].value;
    const { goToCustomer } = this.props;
    goToCustomer(selectedCustomer);
  }

  render() {
    setTimeout(function() {
      const leftSideBarPlaceholder = document.querySelector('.left-sidebar-placeholder');
      if (leftSideBarPlaceholder) {
        leftSideBarPlaceholder.style.display = 'block';
      }
      const leftSideBarFirst = document.querySelector('.left-sidebar-1');
      if (leftSideBarFirst) {
        leftSideBarFirst.style.display = 'block';
      }
    }, 500);
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'workOrder',
      'permTypeKey': 'edit',
      'idForCheckingAuthor': path(['tasks', 'current', 'user_id'], this.props)
    });
    const disableFieldForEdit = !hasAccessForEdit;
    const projectName = path(['projects', 'currentProject', 'name'], this.props);
    const { loading } = this.state;
    const projectId = path(['fields', 'project_id', 'value'], this.state);
    const cameFrom = localStorage.getItem('cameToWOFrom');
    let breadCrumbs;
    switch (cameFrom) {
      case 'calendar':
        breadCrumbs = [
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { eventOnClick: () => window.history.back(), icon: 'perm_contact_calendar', name: 'Calendar' },
          { icon: 'style', name: 'Edit Task' }
        ];
        break;
      case 'quotes-wo':
        breadCrumbs = [
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/quotes', icon: 'format_quote', name: 'Quotes' },
          {
            eventOnClick: () => window.history.back(),
            icon: 'chrome_reader_mode',
            name: localStorage.getItem('lastQuotesWoName')
          },
          { icon: 'style', name: 'Edit Task' }
        ];
        break;
      case 'dashboard':
      default:
        breadCrumbs = [
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/customers', icon: 'account_circle', name: 'Customers' },
          { url: `/pages/project-task/${projectId}`, icon: 'chrome_reader_mode', name: projectName },
          { icon: 'style', name: 'Edit Task' }
        ];
        break;
    }


    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <div>
        {this.renderForm(disableFieldForEdit)}
        {this.renderFields(disableFieldForEdit)}
      </div>;

    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={breadCrumbs}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Edit Task
            </div>
            <div className="card-block">
              <div style={{ paddingBottom: '20px' }} className="float-right">
                <button
                  type="button"
                  className={'btn btn-info btn-outline'}
                  onClick={this.donwloadPdfPreview}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-file-pdf-o"></i>
                  <span style={{ paddingLeft: '3px' }}>Print Preview</span>
                </button>
                <button
                  type="button"
                  className={'btn btn-info btn-outline'}
                  onClick={this.downloadPdfInvoice}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-file-pdf-o"></i>
                  <span style={{ paddingLeft: '3px' }}>Print Invoice</span>
                </button>
                <button
                  type="button"
                  className={'btn btn-info btn-outline'}
                  onClick={this.downloadPdfPreviewShipping}
                  style={{
                    marginLeft: '10px',
                    color: '#000000',
                    borderColor: '#000000'
                  }}
                >
                  <i className="fa fa-file-pdf-o"></i>
                  <span style={{ paddingLeft: '3px' }}>Print Shipping</span>
                </button>
                <button
                  type="button"
                  className={'btn btn-default btn-outline'}
                  onClick={this.clock}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-clock-o"></i>
                  <span style={{ paddingLeft: '3px' }}>Clock</span>
                </button>
                <button
                  type="button"
                  className={'btn btn-default btn-outline'}
                  onClick={this.comments}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-comment-o"></i>
                  <span style={{ paddingLeft: '3px' }}>Comments</span>
                </button>
                <button
                  type="button"
                  className={'btn btn-default btn-outline'}
                  onClick={this.logs}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-info-circle"></i>
                  <span style={{ paddingLeft: '3px' }}>Logs</span>
                </button>
                <button
                  type="button"
                  className={'btn btn-default btn-outline'}
                  onClick={this.attachFile}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-file"></i>
                  <span style={{ paddingLeft: '3px' }}>Attach File</span>
                </button>
                {this.renderSendEmailButton()}
                {hasAccessForEdit && <button
                  type="button"
                  className={'btn btn-success btn-outline'}
                  onClick={this.submit}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
                }
                {hasAccess({
                  'permAreaKey': 'workOrder',
                  'permTypeKey': 'delete',
                  'idForCheckingAuthor': path(['tasks', 'current', 'user_id'], this.props)
                }) &&
                <button
                  type="button"
                  className={'btn btn-danger btn-outline '}
                  style={{ marginLeft: '10px' }}
                  onClick={this.remove}
                >
                  <i className="fa fa-trash"></i>
                  <span style={{ paddingLeft: '3px' }}>Delete</span>
                </button>
                }
              </div>
              <div style={{ clear: 'both' }}>
                {mainPart}
              </div>
            </div>
          </div>
        </div>
        <ConfirmAction id={'deleteWOById'} content={'Are you sure you want to delete this work order?'}/>
        <ConfirmAction id={'deleteSlById'} content={'Are you sure you want to remove the Supply Log for this Vendor?'}/>
        <ConfirmAction id={'deleteSlAll'} content={'Are you sure you want to remove Supply Logs?'}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    editTask: (id, data) => {
      updateTaskById(id, data)(dispatch);
    },
    editAndSendMail: (id, data, supId) => {
      updateTaskByIdAndSendMail(id, data, supId)(dispatch);
    },
    getDataById: (id) => {
      fetchTaskById(id)(dispatch);
    },
    getPdf: (id, wo) => {
      getPdfFile(id, wo)(dispatch);
    },
    getPdfInvoice: (id) => {
      getPdfFileInvoice(id)(dispatch);
    },
    getPdfShipping: (id) => {
      getPdfFileShipping(id)(dispatch);
    },
    goToDashboard: () => {
      dispatch(push('/pages/dashboards'));
    },
    getJobCardsTypes: () => {
      getJobCards()(dispatch)
    },
    getPaintList: () => {
      getPaintListAll()(dispatch)
    },
    getProjects: () => {
      fetchDetailsWithoutProperty()(dispatch);
    },
    getContactList: (id) => {
      getContactsByProjectId(id)(dispatch);
    },
    getTasks: () => {
      fetchAllTasks()(dispatch);
    },
    setNewData: (id, data) => {
      updateTaskProject(id, data)(dispatch);
    },
    sendEmail: (data) => {
      transferEmailByTaskIdAndStageId(data)(dispatch);
    },
    setNewPosition: (data) => {
      adjustTaskPositionByTaskIdAndPosition(data)(dispatch);
    },
    goToComments: (id) => {
      dispatch(push('/pages/comments/' + id));
    },
    goToLogs: (id) => {
      dispatch(push('/pages/logs/' + id));
    },
    goToAttachments: (id) => {
      dispatch(push('/pages/attach/' + id));
    },
    goToClock: (number) => {
      dispatch(push(`/pages/timesheet/wo/${number}`));
    },
    getCustomerList: () => {
      getList()(dispatch);
    },
    getWoIdForCustomer: (id) => {
      return getWORecent(id)(dispatch);
    },
    getCurrentProject: (id) => {
      fetchProjectById({ id, })(dispatch);
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    goToCustomer: (id) => {
      dispatch(push('/pages/edit-customer/' + id))
    },
    getSalesPersonsList: () => {
      getSalesPersonsListAll()(dispatch)
    },
    getVendors: () => {
      getVendorsList()(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteAdd);



// WEBPACK FOOTER //
// ./src/containers/Task/index.js